export const FEATURE_FLAGS = {
  ab_tests: 'Start and manage A/B tests between deployed versions',
  add_voice: 'Add new voice options',
  address_asr_biasing: 'Address ASR biasing issues',
  api_integration: 'API integration management',
  agent_guardrails:
    'Surface configurable behavioural guardrails in Agent Settings',
  agentic_assistant: 'AI assistant for building agents',
  advanced_code_editor: 'Advanced code editor with additional features',
  analytics_dark_theme_header: 'Dark theme for analytics header',
  asr_sonic: 'Sonic ASR (Automatic Speech Recognition) support',
  assistant_analysis: 'Analysis tools for agent performance',
  assistant_analysis_performance_over_time:
    'Performance over time analysis tools for agent performance',
  atlas_model_training:
    'Creates an external nav for the Atlas annotation platform dashboard',
  audio_cache_custom_upload: 'Custom upload for audio cache',
  audio_cache_management: 'Management tools for audio cache',
  barge_in: 'Support for barge-in functionality during calls',
  barge_in_indicator: 'Barge-in indicator in the conversation review',
  builder_assistant: 'Adds the builder agent web chat UI in the project page',
  call_download: 'Ability to download call recordings',
  call_handoff: 'Call handoff between agents or systems',
  celebrate_deployment: 'Celebration feature for successful deployments',
  chat_with_variants:
    'Allow the user to select the variant that they want to chat with',
  content_filters: 'Content filtering capabilities',
  conversation_review_version_filtering:
    'Filter conversation reviews by version',
  conversation_variables_diff: 'Diff view for conversation variables',
  csat_analytics: 'Customer Satisfaction Survey (CSAT) analytics',
  custom_columns: 'Conversations Review Table configurations',
  custom_metrics: 'Support for custom metrics',
  debugging_improvements: 'Agent debugging UI improvements',
  duplicate_custom_metrics:
    'Duplicate custom metrics when duplicating a project',
  disclaimer: 'Display disclaimers in the UI',
  dual_channel_waveform: 'Dual channel call audio waveform',
  'export-kb-spreadsheet': 'Export knowledge base to a spreadsheet',
  'export-var-spreadsheet': 'Export variables to a spreadsheet',
  flow_functions_management: 'Management of flow functions',
  flow_step_dtmf: 'DTMF configuration per flow step',
  function_calls: 'Support for function calls in workflows',
  function_logs: 'Show function event logs in conversation review',
  function_latency_control: 'Control latency for functions',
  function_usage_count: 'Show function usage count in function cards',
  genai_voice: 'GenAI voice capabilities',
  hide_agent_analysis: 'Hide agent analysis for non-allowed accounts',
  global_function_lib: 'Global function library support',
  in_app_calling: 'In-app calling functionality',
  integrations: 'Third party integrations management',
  integrations_configuration: 'Integrations configuration management',
  internal_glot_raw_view: 'Raw event view for Glot assistant debugging',
  'import-kb-spreadsheet': 'Import knowledge base from a spreadsheet',
  'import-var-spreadsheet': 'Import variables from a spreadsheet',
  jobs_to_be_done: 'Jobs-to-be-done framework support',
  jupiter_agent_config: 'Agent configuration in Agent Studio',
  jupiter_analytics: 'Analytics features in Agent Studio',
  jupiter_change_log_notifications: 'Notifications for Agent Studio change log',
  jupiter_change_log: 'Change log for Agent Studio',
  jupiter_custom_dashboards: 'Custom dashboards in Agent Studio',
  jupiter_notes_annotations: 'Notes and annotations in Agent Studio',
  jupiter_overview_dashboard: 'Overview dashboard in Agent Studio',
  jupiter_safety_analytics: 'Safety analytics in Agent Studio',
  jupiter_safety_dashboard: 'Safety dashboard in Agent Studio',
  jupiter_user_management: 'User management in Agent Studio',
  agent_studio_data_access:
    'Data access and API key management in Agent Studio',
  jupiter_variant_attributes: 'Variant attributes in Agent Studio',
  keyphrase_boosting: 'Boosting for key phrases',
  knowledge_base_comparison: 'Comparison tools for knowledge base',
  knowledge_base_pdf_url_import: 'Import a knowledge base from a PDF or URL',
  knowledge_base_topic_toggle: 'Toggle knowledge base topics on/off',
  latency_config: 'Configuration for latency settings',
  llms_coming_soon: 'Placeholder for upcoming LLMs features',
  mask_conversation_pii: 'Mask PII in conversations',
  multi_voice: 'Support for multiple voices',
  no_code_flow: 'No code flow in Agent Studio',
  nebula_conversations_api:
    'Use Nebula API for conversations endpoints instead of Jupiter API',
  outbound_call_link: 'Link to outbound conversations from inbound projects',
  overwrite_rules: 'Rules for overwriting data',
  personal_access_tokens: 'Personal access tokens tab in Account settings',
  playback_speed: 'Playback speed control for audio waveform',
  play_ht_amazon_voices: 'Support for PlayHT and Amazon voices',
  poly_voices: 'Support for Poly voices',
  portal_projects_in_jupiter: 'Portal projects integration in Agent Studio',
  pronunciations: 'Pronunciation management',
  read_only_view: 'Read-only view mode',
  rich_text_lexical: 'New version of the rich text editor',
  realtime_config:
    'Allow builders to configure real-time config pages for managers to use',
  sample_projects: 'Sample projects for demonstration',
  saved_filters: 'Conversation review saved filters',
  secrets_manager: 'Secrets management tools',
  select_language: 'Language selection feature',
  short_conversation_summary: 'Short summaries for conversations',
  smart_analyst: 'Smart analyst POC features',
  smart_analyst_always_on: 'Always show Smart Analyst tab',
  smart_analyst_reasoning: 'Enable reasoning steps for the Smart Analyst',
  smart_analyst_review_messages: 'Review agent messages in Smart Analyst',
  smart_analyst_fast_api: 'Nebula Fast API for the smart analyst',
  smart_analyst_rud_fast_api:
    'Nebula Fast API for Smart Analyst RUD operations',
  sms_templates_metrics: 'Metrics for SMS templates',
  sms_templates: 'Management of SMS templates',
  stop_keywords: 'Stop keywords functionality',
  'stripe-payments': 'Stripe payment integration',
  telephony: 'Telephony features',
  testing: 'Test suite management',
  topic_citations: 'Citations for topics',
  transcript_corrections: 'Corrections for transcripts',
  turn_latency: 'Turn latency',
  variant_attributes_in_content: 'Variant attributes in content',
  voice_configs: 'Configuration for voice settings',
  variant_switching: 'Switching between variants',
  turn_annotation: 'Feature to annotate agent responses per turn',
  latency_viz: 'Latency visualization',
  event_sourcing: 'Event sourcing (ALPHA)',
  poly_score: 'Feature to show the poly score in conversations',
  quicksight_dashboards: 'AWS Quicksight dashboards feature',
  asr_select: 'ASR (Automatic Speech Recognition) selection feature',
  voice_speed_controls: 'Voice speed controls for supported providers',
  home_page: 'Home page for the Agent Studio',
  saferide_api_dd_logs: 'Feature to allow Saferide access to API logs',
  test_sets: 'Test sets management',
  test_case_with_new_navigation:
    'Feature to enable the new navigation in the test case detail screen',
  webchat_configuration: 'Webchat configuration',
  source_hub: 'Source Hub for managing external knowledge sources',
  source_citation_side_panel:
    'Open source citations in the conversation review side panel',
  append_file_import: 'Append to existing topics on file import',
  site_maintenance: 'Site maintenance mode',
  test_set_run_on_deployment: 'Run test set on deployment',
  product_led_growth: 'Product led growth features',
  knowledge_variants: 'Variants tab in Knowledge screen',
  entity_validation: 'No code flow - Entity validation',
  live_call_listening: 'Live call listening feature',
  variables: 'Variables support in rich text editor and functions',
  chat_channel_selection: 'Channel selection in chat panel (webchat/voice)',
  language_chat_select: 'Language selection dropdown in chat and call panels',
  dark_mode: 'Dark mode theme support',
  multilingual_config: 'Multilingual configuration support',
  function_step: 'Function step support in no code flow',
  plg_survey: 'Survey feature for the plg agent wizard',
  language_hub: 'Language hub for managing multilingual content',
  agent_setup_project_cache:
    'Use cached README from the same project in agent setup',
  agent_setup_global_cache:
    'Use cached README from any project with same company URL in agent setup',
  channel_specific_settings: 'Channel specific settings',
  zoom_demo: 'Zoom demo mode with custom integrations and sample projects',
  csat_voice: 'Customer Satisfaction Survey (CSAT) configuration',
  template_engine: 'Template engine support for child projects',
  user_management_v2: 'User management v2 in Agent Studio',
  experimental_configuration_form: 'Show experimental configuration in a form',
  cookies_enabled: 'Enables cookie consent requirements for analytics tracking',
  integrations_upsell:
    'Add an enterprise upsell banner for all unconfigured integrations',
  paragon_integrations: 'Paragon integrations',
  mimic_plg_prod:
    'WARNING: Only enable for yourself. Mimics PLG prod environment behavior for testing. NEVER turn on for everyone.',
  paragonServiceNow: 'Paragon ServiceNow integration',
  paragonZoom: 'Paragon Zoom integration',
  paragonJira: 'Paragon Jira integration',
  paragon_secrets: 'Store Paragon credentials in secrets instead of artifact',
  serviceNowIntegrationsPage: 'Show ServiceNow on the integrations page',
  googleCalendarIntegrationsPage:
    'Show Google Calendar on the integrations page',
  nonParagonServiceNow: 'Non-Paragon ServiceNow integration',
  webrtc_calling: 'Use WebRTC gateway for in-app calling',
  voice_page_revamp:
    'Voice page revamp with new voice library and UI improvements',
  mergedKnowledge: 'Merged knowledge base and source hub',
  chat_panel_v2: 'Chat panel v2 refactor',
  new_voice_providers: 'Support for Cartesia and Hume voice providers',
  auto_fill_function_references:
    'Auto-fill function references in agent settings',
  paragon_slack: 'Paragon Slack integration',
  paragon_notion: 'Paragon Notion integration',
  paragon_google_drive: 'Paragon Google Drive integration',
  paragon_google_sheets: 'Paragon Google Sheets integration',
  paragon_microsoft_teams: 'Paragon MS Teams integration',
  paragon_microsoft_outlook: 'Paragon MS Outlook integration',
  paragon_one_drive: 'Paragon OneDrive integration',
  paragon_confluence: 'Paragon Confluence integration',
  paragon_freshdesk: 'Paragon Freshdesk integration',
  paragon_sharepoint: 'Paragon SharePoint integration',
  global_search: 'Global search functionality across the application',
  mcp_integrations_ui: 'MCP Integrations tab on the Integrations screen',
  paragon_tripleseat: 'Show Tripleseat on the integrations page',
  llm_testify: 'LLM driven testify tests',
  devtools_mcp: 'Devtools MCP server for event sourcing debugging',
  api_keys_tab: 'Replace Data Acess tab with API Keys tab',
  paragon_hubspot: 'Paragon HubSpot integration',
  model_configuration: 'Model configuration page for voice channel',
  template_integrations:
    'Integrations available for template engine child projects',
  paragon_microsoft_dynamics: 'Paragon Microsoft Dynamics integration',
  webrtc_shareable_link: 'Generate a webRTC voice only page link',
  paragon_sharepoint_sourcehub: 'add Sharepoint to SourceHub',
  paragon_zendesk: 'Paragon Zendesk integration',
  messagingHandoffIntegrationsPage:
    'Show NICE and Zendesk messaging handoff tiles on the integrations page',
  five9_integration: 'Show Five9 in integrations page',
  dialpad_integration: 'Show dialpad in integrations page',
  full_fake_integration:
    'Enable fake-full-integration demo sort on the integrations page',
  tts_rules_reordering: 'TTS rules reordering with accordion UI',
  template_engine_settings: 'Set project as a template in settings page',
  create_from_template: 'Create new projects from templates',
  opentable_integration_page: 'Show OpenTable on the integrations page',
  glot_gateway: 'Route Glot WebSocket through the new glot-gateway service',
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

export const CONVERTER_POLICY_FLAGS = {
  paragon_integrations: FEATURE_FLAGS.paragon_integrations,
  channel_specific_settings: FEATURE_FLAGS.channel_specific_settings,
  multilingual_config: FEATURE_FLAGS.multilingual_config,
  language_hub: FEATURE_FLAGS.language_hub,
  csat_voice: FEATURE_FLAGS.csat_voice,
} as const satisfies Partial<typeof FEATURE_FLAGS>;

export type ConverterPolicy = keyof typeof CONVERTER_POLICY_FLAGS;
